import { render, staticRenderFns } from "./FacilityInfo.vue?vue&type=template&id=6b34b8be&scoped=true&"
import script from "./FacilityInfo.vue?vue&type=script&lang=ts&"
export * from "./FacilityInfo.vue?vue&type=script&lang=ts&"
import style0 from "./FacilityInfo.vue?vue&type=style&index=0&id=6b34b8be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b34b8be",
  null
  
)

export default component.exports